import { type ColumnRenderer, ImgElement } from '@axinom/mosaic-ui';
import React, { type ReactNode } from 'react';
import { getServiceDeploymentStatusIconLabel } from '../common/utils';
import type { CustomizableServiceDeploymentData } from './CustomizableServiceDeploymentCreate.types';
import classes from './ServiceDeploymentStatusRenderer.module.scss';

export const DeploymentStatusRenderer: ColumnRenderer<
  CustomizableServiceDeploymentData
> = (_value, data): ReactNode => {
  const { icon, label } = getServiceDeploymentStatusIconLabel(data?.status);

  return (
    <div className={classes.status_container}>
      <ImgElement
        src={icon}
        style={{ width: '20px', height: '20px' }}
        decorative={true}
      />
      <div className={classes.status}>{label}</div>
    </div>
  );
};

export const ArtifactUsedInDeploymentRenderer = (value: unknown): ReactNode => {
  return (
    <div className={classes.status}>{value ? 'Deployed' : 'Not Deployed'}</div>
  );
};

export const ActiveDeploymentRenderer = (value: unknown): ReactNode => {
  return <div className={classes.status}>{value ? 'Yes' : 'No'}</div>;
};
